import * as React from "react";
import IntegratedDataLoading from "src/scenes/dashboard/integrated-data-loading";
import IntegratedInactive from "src/scenes/dashboard/integrated-inactive";
import IntegratedNoResponse from "src/scenes/dashboard/integrated-no-response";
import { useEffect } from "react";

const useLoadingAndInactiveDataHandler = ({
    name,
    fetchAction,
    isIntegrationInvalid,
}): {
    loadingAndInactiveHandler: React.ReactNode | undefined;
} => {
    const [loadingAndInactiveHandler, setLoadingAndInactiveHandler] = React.useState<
        React.ReactNode | undefined
    >();
    const [skip, setSkipped] = React.useState(false);

    const dataLoading =
        fetchAction &&
        fetchAction.data &&
        fetchAction.data.meta &&
        !fetchAction.data.meta.firstScrappedDate &&
        !fetchAction.data.meta.lastActiveAt;

    const inactive =
        fetchAction && fetchAction.data && fetchAction.data.meta && fetchAction.data.meta.inactive;

    useEffect(() => {
        if (!fetchAction) {
            setLoadingAndInactiveHandler(<IntegratedNoResponse />);
        } else if (dataLoading) {
            setLoadingAndInactiveHandler(<IntegratedDataLoading name={name} />);
        } else if (isIntegrationInvalid && inactive) {
            setLoadingAndInactiveHandler(
                <IntegratedInactive
                    name={name}
                    isInvalid
                    skipAction={null}
                    lastActiveAt={null}
                    firstScrappedDate={null}
                />
            );
        } else if (isIntegrationInvalid && !inactive && !skip) {
            setLoadingAndInactiveHandler(
                <IntegratedInactive
                    name={name}
                    isInvalid
                    skipAction={(e: boolean) => setSkipped(e)}
                    lastActiveAt={null}
                    firstScrappedDate={null}
                />
            );
        } else if (inactive) {
            setLoadingAndInactiveHandler(
                <IntegratedInactive
                    name={name}
                    lastActiveAt={fetchAction.data.meta.lastActiveAt}
                    firstScrappedDate={fetchAction.data.meta.firstScrappedDate}
                    skipAction={null}
                    isInvalid={false}
                />
            );
        } else {
            setLoadingAndInactiveHandler(undefined);
        }
    }, [dataLoading, inactive, skip]);

    return { loadingAndInactiveHandler };
};

export default useLoadingAndInactiveDataHandler;
